import React from 'react';
import './checkbox.styles.scss';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';
import { TickIcon } from '../../icons';

export interface CheckboxProps {
	name: string;
	value?: string;
	label?: string | React.ReactNode;
	wrapperClass?: string;
	hideIcon?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	id?: string;
	required?: boolean;
	checked?: boolean;
	defaultChecked?: boolean;
	title?: string;
}

export const CustomCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	(
		{
			name,
			label,
			wrapperClass = '',
			children,
			hideIcon,
			onChange,
			disabled,
			id,
			value = '',
			required,
			checked,
			defaultChecked,
			title,
		},
		ref,
	) => {
		return (
			<Tooltip title={title}>
				<label
					htmlFor={id || name}
					className={classNames('checkbox', wrapperClass, {
						disabled,
						isChecked: checked,
					})}
				>
					<input
						id={id || name}
						name={name}
						ref={ref}
						type="checkbox"
						className="checkbox__input"
						value={value}
						onChange={onChange}
						disabled={disabled}
						checked={checked}
						defaultChecked={defaultChecked}
						required={required}
					/>

					{hideIcon || <TickIcon iconClass="checkbox__icon" />}
					{label && <span className="radio__label">{label}</span>}
					{children}
				</label>
			</Tooltip>
		);
	},
);
